export const SEARCH_HEIGHT = 80;
export const SEARCH_HEIGHT_TABLET = 85;
export const SEARCH_HEIGHT_DESKTOP = 110;
export const DROPDOWN_NAV_HEIGHT = 60;
export const SIDE_NAV_WIDTH = 420;
